/**
 * Konstanten der Einkaufsverwaltung: Bestellwesen, Wareneingang und
 * 3-Wege-Rechnungsprüfung. Backend und Oberfläche teilen sich diese Werte,
 * damit Prüfergebnis und Anzeige nicht auseinanderlaufen.
 */
export const PURCHASE_ORDER_STATUSES = [
    'DRAFT',
    'SENT',
    'CONFIRMED',
    'PARTIALLY_RECEIVED',
    'RECEIVED',
    'BILLED',
    'CANCELLED',
];
/** Solange kein Wareneingang gebucht ist, bleiben Kopf und Positionen änderbar. */
export const PURCHASE_ORDER_EDITABLE_STATUSES = [
    'DRAFT',
    'SENT',
    'CONFIRMED',
];
export const PURCHASE_ORDER_CANCELLABLE_STATUSES = [
    'DRAFT',
    'SENT',
    'CONFIRMED',
];
export const GOODS_RECEIPT_STATUSES = ['DRAFT', 'POSTED', 'CANCELLED'];
/** Qualitätsurteil des Lagers; nur angenommene Ware erhöht den verfügbaren Bestand. */
export const GOODS_RECEIPT_QUALITY_STATUSES = [
    'ACCEPTED',
    'DAMAGED_REJECTED',
    'UNDER_QUARANTINE',
];
export const VENDOR_INVOICE_STATUSES = [
    'DRAFT',
    'MATCHED',
    'DISCREPANCY',
    'APPROVED_FOR_PAYMENT',
    'PAID',
    'CANCELLED',
];
export const THREE_WAY_MATCH_STATUSES = [
    'PERFECT_MATCH',
    'TOLERANCE_ACCEPTED',
    'PRICE_MISMATCH',
    'QTY_MISMATCH',
    'MANUALLY_OVERRIDDEN',
];
/** Abgleichergebnisse, die eine Zahlungsfreigabe zulassen. */
export const THREE_WAY_MATCH_CLEARED_STATUSES = [
    'PERFECT_MATCH',
    'TOLERANCE_ACCEPTED',
    'MANUALLY_OVERRIDDEN',
];
// ---------------------------------------------------------------------------
// Toleranzen der Rechnungsprüfung
// ---------------------------------------------------------------------------
/** Rundungsdifferenz je Position, die ohne Rückfrage akzeptiert wird. */
export const MATCH_TOLERANCE_ABSOLUTE_DEFAULT = '0.05';
/** Zusätzliche relative Toleranz in Prozent für Preis und Menge. */
export const MATCH_TOLERANCE_PERCENT_DEFAULT = '0.5';
export const MATCH_TOLERANCE_ABSOLUTE_MAX = '100';
export const MATCH_TOLERANCE_PERCENT_MAX = '25';
// ---------------------------------------------------------------------------
// Grenzen
// ---------------------------------------------------------------------------
export const PURCHASE_ORDER_ITEM_MAX_COUNT = 200;
export const PURCHASE_ORDER_TEXT_MAX_LENGTH = 2000;
export const PURCHASE_PAYMENT_TERMS_MAX_DAYS = 365;
/** Lieferschein-Scans und Rechnungs-PDFs; deckt mehrseitige Scans ab. */
export const PROCUREMENT_DOCUMENT_MAX_BYTES = 10_485_760;
export const PROCUREMENT_DOCUMENT_MIME_TYPES = [
    'application/pdf',
    'image/jpeg',
    'image/png',
    'image/webp',
];
export const PURCHASE_ORDER_SORT_FIELDS = [
    'purchaseOrderNumber',
    'orderDate',
    'expectedDeliveryDate',
    'grossTotal',
    'status',
];
export const VENDOR_INVOICE_SORT_FIELDS = [
    'invoiceNumber',
    'invoiceDate',
    'dueDate',
    'grossAmount',
    'status',
];
export const GOODS_RECEIPT_SORT_FIELDS = ['receiptNumber', 'receivedDate', 'status'];
/** Vorlauf in Tagen, ab dem ein Skontofenster im Fälligkeits-Dashboard hervorgehoben wird. */
export const CASH_DISCOUNT_WARNING_DAYS = 3;
//# sourceMappingURL=procurement.js.map